jQuery(document).ready(function(){
	var pj = GetURLParameter('pj');
    var qty = GetURLParameter('qnt');
    if(typeof qty == 'undefined'){
        qty='';
      }else{
        jQuery('#Quantity').val(qty);
      }
    if(typeof pj == 'undefined'){
      pj='';
    }else{
      pj='&pj='+pj;
      setTimeout( function() {jQuery('#personalize').trigger('click'); },1000);
    }
   
    
    /** remove comment if want to split description
    if  (jQuery('#SingleOptionSelector-1').is(":visible")) {
      var test = jQuery('#SingleOptionSelector-1 option:selected').attr("op-select");
    }else{
    	var test = jQuery('.single-option-selector option:selected').attr("op-select");
    }
    
    if(typeof test == 'undefined'){
   	 jQuery('.product-single__description').show();
    }else{
      jQuery('.product-single__description').hide();
      	jQuery('.'+test+'').show();
    }
    jQuery('.single-option-selector').change(function(){
    	if  (jQuery('#SingleOptionSelector-1').is(":visible")) {
          var test = jQuery('#SingleOptionSelector-1 option:selected').attr("op-select");
        }else{
            var test = jQuery('.single-option-selector option:selected').attr("op-select");
        }
      
      	jQuery('.product-single__description').hide();
      	jQuery('.'+test+'').show();
    });
    **/
    jQuery('.single-option-selector').change(function(){
      jQuery('#personalize .personalyze-text').css({'color':'white'});
      setTimeout( function() {
        jQuery('#personalize .personalyze-text').css({'color':'#222'});
    	var pid = jQuery('select[name="id"] option:selected').attr('value');
        var barcode = jQuery('.barcode_holder div.'+pid).text();
        if(typeof pid == 'undefined' || barcode == ''){
          pid = jQuery('input[name="id"]').val();
          barcode = jQuery('.barcode_holder div.'+pid).text();
        }
      var cur_text = jQuery('#personalize .personalyze-text').text();
        if(cur_text.toUpperCase() != "SOLD OUT"){
          if(barcode.indexOf('POD') == 0){
            jQuery('.personalyze-text').text('Add To Cart');
            jQuery('#personalize').prop('disabled', false);
          }else{
            jQuery('.personalyze-text').text('Personalize');
            jQuery('#personalize').prop('disabled', false);
          }
        }else{
          jQuery('.personalyze-text').text('Sold out');
          jQuery('#personalize').prop('disabled', true);
        }
      },200);
    });
  
  setTimeout( function() {
  	//jQuery('.shopify-payment-button').hide();
  },200);
  
});
jQuery(window).load(function(){
  setTimeout( function() {
    var pid = jQuery('select[name="id"] option:selected').attr('value');
    var barcode = jQuery('.barcode_holder div.'+pid).text();
    if(typeof pid == 'undefined' || barcode == ''){
      pid = jQuery('input[name="id"]').val();
      barcode = jQuery('.barcode_holder div.'+pid).text();
    }
    
    if(barcode.indexOf('POD') == 0){
      jQuery('.personalyze-text').text('Add To Cart');
    }else{
      jQuery('.personalyze-text').text('Personalize');
    }
  },200);         
}); 

//CUSTOMIZE BUTTON
jQuery('#personalize').click(function(e){
    e.preventDefault();
    personalize();
});

jQuery('.personalize').click(function(e){
    e.preventDefault();
    personalize();
});

function personalize(){
  localStorage['specialInstruction']='';
  var server = window.location.hostname;
  var pid = jQuery('select[name="id"] option:selected').attr('value');
  var barcode = jQuery('.barcode_holder div.'+pid).text();
  if(typeof pid == 'undefined' || barcode == ''){
    pid = jQuery('input[name="id"]').val();
    barcode = jQuery('.barcode_holder div.'+pid).text();
  }

  var vendor = jQuery('.barcode_holder div.vendor_'+pid).text();
  var option1 = jQuery('.barcode_holder div.option1_'+pid).text();
  var option2 = jQuery('.barcode_holder div.option2_'+pid).text();
  var option3 = jQuery('.barcode_holder div.option3_'+pid).text();
  var config = jQuery('.barcode_holder div.config_'+pid).text();
  var mconfig = jQuery('.barcode_holder div.mconfig_'+pid).text();
  var layout = jQuery('.barcode_holder div.layout_'+pid).text();
  var mlayout = jQuery('.barcode_holder div.mlayout_'+pid).text();
  var locale = jQuery('.barcode_holder div.locale_'+pid).text();
  var mlocale = jQuery('.barcode_holder div.mlocale_'+pid).text();
  var gallery = jQuery('.barcode_holder div.gallery_'+pid).text();
  var css = jQuery('.barcode_holder div.css_'+pid).text();
  var renderer = jQuery('.barcode_holder div.renderer_'+pid).text();
  var etc = jQuery('.barcode_holder div.etc_'+pid).text();
  var metc = jQuery('.barcode_holder div.metc_'+pid).text();
  var quantity = jQuery('#Quantity').val();
  var redirect = "&redirect={{ product.url }}";
  if(typeof quantity == 'undefined'){
    quantity = 1;
  }
  var SpecialInstruction = jQuery('#note').val();
  localStorage['specialInstruction']=SpecialInstruction;
  var color = "nocolor";
  var size = "nosize";
  var hex='';
  if(option1.length != 0){
    var attr = option1.split("_");
    if (attr[1].toUpperCase() === "SIZE") {
      size = attr[0];
    }
    var attr = option1.split("_");
    if (attr[1].toUpperCase() === "COLOR" || attr[1].toUpperCase() === "COLOUR") {
      color = attr[0];
    }
  }
  if(option2.length != 0){
    var attr = option2.split("_");
    if (attr[1].toUpperCase() === "COLOR" || attr[1].toUpperCase() === "COLOUR") { 
      color = attr[0];
    }
    var attr = option2.split("_");
    if (attr[1].toUpperCase() === "SIZE") {
      size = attr[0];
    }
  }
  if(option3.length != 0){
    var attr = option3.split("_");
    if (attr[1].toUpperCase() === "COLOR" || attr[1].toUpperCase() === "COLOUR") {
      color = attr[0];
    }
    var attr = option3.split("_");
    if (attr[1].toUpperCase() === "SIZE") {
      size = attr[0];
    }
  }

  if(color !='nocolor'){
    hex = color.split('|');
    color = hex[0].replace(/\s/g, '');
    if(hex.length >1){
      	var str = hex[1].replace(/\s/g, '');
  		hex = '&hex=' + str;
    }else{
    	hex='';
    }
  }
  
  etc = etc.replace(/&/gi,'|');
  etc = etc.replace('|','&');
  metc = metc.replace(/&/gi,'|');
  metc = metc.replace('|','&');
  if(barcode.indexOf('POD') == 0){
    
    var myform = jQuery('#personalize').closest('form');
    barcode = barcode.replace('POD','');
    myform.append('<input type="hidden" name="properties[_barcode]" value="'+barcode+'" /><input type="hidden" name="properties[_server]" value="'+server+'" /><input type="hidden" name="properties[_vendor]" value="'+vendor+'" />');
    setTimeout(function() {
      myform.submit();
    }, 1); 
    
  }else{
 	var sid = 'sid=' + pid;
    var server = window.location.hostname;
    var pj = GetURLParameter('pj');
    var qnt = GetURLParameter('qnt');
    
    if(typeof qnt != 'undefined'){
     quantity=qnt;
    }
    
    if(typeof pj == 'undefined'){
      pj='';
    }else{
      pj='&pj='+pj;
    }
    var linkurl =  sid +'&vendor='+ vendor +'&gid='+ barcode +'&qnt=' + quantity + "&color=" +color + "&size=" + size + hex + config + mconfig + layout + mlayout + locale + mlocale + gallery + renderer + metc + etc + redirect + css + pj +'&virtual=no';
    var domainurl = 'https://prod2.ipersonalyzenetwork.com/integration/hidratespark/api?action=design&domain='+ server;
  	var iframeurl = domainurl + '&' + linkurl;
    
    if(jQuery(window).width() > 850){
      
     
      jQuery.fancybox1.open({
      src  : iframeurl,
      type : 'iframe',
      opts : {
          beforeShow: function(){
              jQuery("#wrapthewrap").css({'overflow':'hidden'});
          },
          afterClose: function(){
              jQuery("#wrapthewrap").css({'overflow':'visible'});
          },
          touch: {
            vertical: false, // Allow to drag content vertically
            momentum: false // Continue movement after releasing mouse/touch when panning
          },
        clickSlide : false
      }
      });
       /**
      var cwidth = jQuery(window).width()*0.9;
      if(width>840)width=1080;
      var cheight = jQuery(window).height()*0.9;
      if(height>560)height=560;
	  **/
    }else{
      var width = window.innerWidth ? window.innerWidth : jQuery(window).width();
      var height = window.innerHeight ? window.innerHeight -30 : jQuery(window).height()-30;
      window.scrollTo(1,0);
      jQuery('html').addClass('customiser-on');
      jQuery('#customiser-helper .inner').html('<iframe style="width:'+width+'px; height:'+height+'px" src="'+iframeurl+'"></iframe>');
      jQuery('#customiser-helper').fadeIn();
	  jQuery('.site-header').hide();
      jQuery('#customiser-helper #customiser-back').click(function(e){
        e.preventDefault();
        jQuery('.site-header').show();
        jQuery('#customiser-helper').fadeOut();
        jQuery('html').removeClass('customiser-on');
      });

      jQuery(window).resize(function(){
        var width = window.innerWidth ? window.innerWidth : jQuery(window).width();
        var height = window.innerHeight ? window.innerHeight -30 : jQuery(window).height()-30;
        jQuery('#customiser-helper iframe').css({'width':width,'height':height});
      });
      
    }
  }
}
function GetURLParameter(sParam){

    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

    for (var i = 0; i < sURLVariables.length; i++)
    {

        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        {

            return sParameterName[1];

        }
    }
}
